module.exports = __webpack_public_path__ + "img/4.4de9310a.png";